/**
 * Get last video.
 * @module actions/videoListing
 */
export const GET_LASTVIDEO = 'GET_LASTVIDEO';

/**
 * Get last video.
 * @function getLastVideo
 * @returns {Object} The last published video.
 */
export function getLastVideo(lang) {
  return {
    type: GET_LASTVIDEO,
    request: {
      op: 'get',
      path: `@search?portal_type=Video&sort_on=effective&sort_order=reverse&sort_limit=1&Language=${lang}`,
      /* `/${lang}/@search?portal_type=Video&sort_on=effective&sort_order=reverse&sort_limit=1` */
    },
  };
}
